import { render, staticRenderFns } from "./CertificateSettings.vue?vue&type=template&id=46d01fef"
import script from "./CertificateSettings.vue?vue&type=script&lang=js"
export * from "./CertificateSettings.vue?vue&type=script&lang=js"
import style0 from "./CertificateSettings.vue?vue&type=style&index=0&id=46d01fef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports